import { alpha, Chip, Stack, styled, Typography, useTheme } from '@mui/material';
import { startCase } from 'lodash';
import { UserIcon } from 'src/components/Icons';
import PlatformIcon from 'src/components/Icons/PlatformIcon';
import Table from 'src/components/Table';
import { EmptyText } from 'src/utils/constants/config';
import { formatUrlNonProtocol, getColorPercentMatch, renderNumberOrDefault } from 'src/utils/helpers/stringHelpers';

export const StyledIcon = styled(UserIcon)(({ theme }) => ({
  background: alpha(theme.palette.primary.main, 0.07),
  color: theme.palette.primary.light,
  padding: theme.spacing(0.5),
  borderRadius: '100%',
  fontSize: 22,
}));

export const StyledLink = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.secondary.main,
}));

const SocialMediaAI = ({
  title,
  listSocial,
  loading = false,
}: {
  title: string;
  listSocial: ISocialMediaAIItem[];
  loading?: boolean;
}) => {
  const theme = useTheme();

  const configColumn: ConfigCell<ISocialMediaAIItem>[] = [
    {
      disablePadding: false,
      id: 'name',
      label: 'Account',
      cell: (data: ISocialMediaAIItem) => (
        <Stack alignItems={'center'} direction={'row'} spacing={1}>
          <StyledIcon />
          <Typography color={theme.palette.text.secondary} variant="body2">
            {data.display_name || EmptyText}
          </Typography>
        </Stack>
      ),
    },
    {
      disablePadding: false,
      id: 'type',
      label: 'Platform',
      cell: (data: ISocialMediaAIItem) => (
        <Stack alignItems={'center'} direction={'row'} spacing={1}>
          <PlatformIcon id={data.platform || ''} sx={{ fontSize: 'large' }} />
          <Typography color={theme.palette.text.secondary} variant="body2">
            {startCase(data?.platform || '') || EmptyText}
          </Typography>
        </Stack>
      ),
    },
    {
      disablePadding: false,
      id: 'confidence',
      label: 'Confidence',
      cell: (data: ISocialMediaAIItem) => {
        const AIConfidence = data?.confidence || 0;
        return (
          <Stack alignItems={'flex-start'} direction={'column'} spacing={1}>
            <Chip
              size="small"
              color={getColorPercentMatch((data.confidence || 0) * 100)}
              label={`AI_INFERRED ${renderNumberOrDefault(AIConfidence * 100)}%`}
            />
          </Stack>
        );
      },
    },
    {
      disablePadding: false,
      id: 'url',
      label: 'URL Detail',
      cell: (data: ISocialMediaAIItem) =>
        data.url ? (
          <StyledLink target="_blank" href={formatUrlNonProtocol(data.url)}>
            {formatUrlNonProtocol(data.url)}
          </StyledLink>
        ) : (
          <Typography variant="body2">{EmptyText}</Typography>
        ),
    },
  ];

  return (
    <Stack spacing={1}>
      <Typography variant="h5" align="left">
        {title}
      </Typography>
      <Table data={listSocial} configColumn={configColumn} dataKey="platform" isPagination={false} loading={loading} />
    </Stack>
  );
};

export default SocialMediaAI;
